module.exports = __webpack_public_path__ + "img/kpi.40b77808.png";